module.exports = __webpack_public_path__ + "65658112018b1c805e23b46fdd232aa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Bottle/bottle.png
// module id = 395
// module chunks = 0